// extracted by mini-css-extract-plugin
export var animationAbsolute = "_3r-q";
export var animationRelative = "_3r-p";
export var backdropBlur = "_3r-0";
export var detailLabelCell = "_3r-12";
export var detailTable = "_3r-11";
export var detailValueCell = "_3r-13";
export var docIconBox = "_3r-1d";
export var docIconBoxMd = "_3r-1f";
export var docIconBoxSm = "_3r-1e";
export var docTypeRow = "_3r-16";
export var docTypeRowInner = "_3r-17";
export var dropdownMatchDatePicker = "_3r-3";
export var evidenceCardContent = "_3r-1c";
export var fileUploadSpin = "_3r-j";
export var gorgiasOpenButton = "_3r-15 _3r-d";
export var gorgiasTicketCard = "_3r-14";
export var heroModalFooterButton = "_3r-18";
export var hiddenContainer = "_3r-o";
export var iconPrimary = "_3r-1g";
export var iconQuaternary = "_3r-1i";
export var iconTertiary = "_3r-1h";
export var integrationCard = "_3r-1";
export var integrationLogoBox = "_3r-2";
export var mainColumnSticky = "_3r-1b";
export var maxWidthContainer = "_3r-19";
export var modalContentBody = "_3r-a";
export var modalHeaderImage = "_3r-5";
export var modalImageLabel = "_3r-7";
export var modalImageOverlay = "_3r-6";
export var modalImageSubtitle = "_3r-9";
export var modalImageTitle = "_3r-8";
export var modalImageWrapper = "_3r-4";
export var modalStickyFooter = "_3r-b";
export var removeButton = "_3r-e";
export var sidebarColumn = "_3r-1a";
export var spinner = "_3r-i";
export var timelineLine = "_3r-y";
export var timelineLineBlack = "_3r-10 _3r-y";
export var timelineLineGray = "_3r-z _3r-y";
export var timelineLineHeight = "_3r-x";
export var tlDotActivate = "_3r-u";
export var tlDotActivateAnim = "_3r-t";
export var tlDotHide = "_3r-s";
export var tlDotHideAnim = "_3r-r";
export var tlLineActivate = "_3r-w";
export var tlLineActivateAnim = "_3r-v";
export var uploadHint = "_3r-n";
export var uploadIconBox = "_3r-k";
export var uploadLabel = "_3r-m";
export var uploadText = "_3r-l";
export var uploadZone = "_3r-f";
export var uploadZoneCursorDefault = "_3r-h";
export var uploadZoneCursorPointer = "_3r-g";
export var uploadedFileRow = "_3r-c";
export var viewButton = "_3r-d";